import { Injectable } from '@angular/core';
import { Settings } from './app.settings.model';

@Injectable()
export class AppSettings {
    public settings = new Settings(
        'iDrv Public Booking',
        'Angular Admin Template with Bootstrap 4',
        {
            menu: 'horizontal', //horizontal , vertical
            menuType: 'default', //default, compact, mini
            showMenu: true,
            navbarIsFixed: true,
            footerIsFixed: false,
            sidebarIsFixed: true,
            showSideChat: false,
            sideChatIsHoverable: false,
            skin:'light'  //light , dark, blue, green, combined, purple, orange, brown, grey, pink          
        }
    )
}